module.exports = __webpack_public_path__ + "static/media/audio-14-tt.e63b3033.mp3";